import { MapPin, ArrowRight, Navigation } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { COMPANY, MAPS_URL, scrollToId } from "../constants";

export const ServiceArea = () => (
  <section id="einsatzgebiet" className="bg-ice/50 py-16 md:py-24" data-testid="service-area-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <Reveal>
        <Chapter number="06" label="Einsatzgebiet" />
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-ink">
          Gebäudereinigung in Lehrte &amp; Umgebung
        </h2>
        <p className="mt-6 text-base sm:text-lg text-mutedtext leading-relaxed">
          Als Reinigungsfirma in Lehrte betreuen wir Unternehmen, Hausverwaltungen und
          Gewerbetreibende in Lehrte und der umliegenden Region Hannover. Ob Büroreinigung,
          Gewerbereinigung, Fensterreinigung oder Treppenhausreinigung – wir sind vor Ort
          und kurzfristig für Sie erreichbar.
        </p>
        <p className="mt-4 text-base text-mutedtext leading-relaxed">
          Durch unsere Nähe bleiben wir flexibel: Besichtigungstermine, Abstimmungen und
          regelmäßige Reinigungstermine lassen sich unkompliziert und passend zu Ihrem
          betrieblichen Ablauf planen.
        </p>

        <div className="mt-8 rounded-2xl bg-white border border-gray-200 p-6" data-testid="google-maps-card">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 rounded-full bg-ice flex items-center justify-center shrink-0">
              <MapPin className="w-5 h-5 text-brand" />
            </span>
            <div>
              <p className="font-heading font-semibold text-ink">Finden Sie uns auf Google</p>
              <p className="text-sm text-mutedtext">
                {COMPANY.name} · {COMPANY.street} · {COMPANY.city}
              </p>
            </div>
          </div>
          <a
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-brand hover:gap-3 transition-all duration-200"
            data-testid="google-maps-link"
          >
            <Navigation className="w-4 h-4" />
            Anfahrt in Google Maps ansehen
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        <button
          onClick={() => scrollToId("kontakt")}
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand hover:bg-brand-dark text-white font-semibold px-7 py-3.5 transition-all duration-200 hover:scale-[1.03]"
          data-testid="area-cta-angebot"
        >
          Angebot für Ihr Objekt anfragen
          <ArrowRight className="w-4 h-4" />
        </button>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="relative rounded-3xl overflow-hidden border border-gray-200 shadow-[0_30px_60px_-30px_rgba(11,25,44,0.35)]">
          <img
            src="https://images.pexels.com/photos/29502230/pexels-photo-29502230.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Glasfassade eines modernen Gewerbegebäudes – Fensterreinigung in Lehrte"
            className="w-full h-[320px] sm:h-[420px] object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-navy/80 via-navy/10 to-transparent" />
          <p className="absolute bottom-5 left-6 text-white font-heading text-lg font-medium">
            Lehrte &amp; Region Hannover
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
